var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPicture = function SvgPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 438
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183 128c0 15-6 28-16 38-11 11-24 16-39 16-16 0-28-5-39-16-11-10-16-23-16-38 0-16 5-29 16-39 11-11 23-16 39-16 15 0 28 5 39 16 10 10 16 23 16 39zm292 109v128H73v-55l91-91 46 46 146-147 119 119zm28-201H45c-2 0-4 1-6 3s-3 4-3 6v348c0 2 1 4 3 6s4 3 6 3h458c2 0 4-1 6-3s3-4 3-6V45c0-2-1-4-3-6s-4-3-6-3zm45 9v348c0 12-4 23-13 32s-20 13-32 13H45c-12 0-23-4-32-13S0 405 0 393V45c0-12 4-23 13-32S33 0 45 0h458c12 0 23 4 32 13s13 20 13 32z"
  })));
};

export default SvgPicture;